import { Component, Inject, ViewContainerRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { OrdinalDateAdapter, ORD_DATE_FORMATS, OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { AttachImplementModalService } from './attach-implement-modal.service';
import { EquipmentList, AttachImplementModalData } from './attach-implement-modal';
import { GETInventoryService } from '../services/inventory.service';
import { ErrorCode, ErrorMessages } from '../entities/global/error-codes';
import { GenericIdName, ImplementMakeModelVM } from '../setup-implement/setup-implement.model';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { CustomerSelectItem, EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { JobsiteSelectionFilter } from '../favourite-dialog/favourite-dialog-modal';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'attach-implement-modal',
    templateUrl: './attach-implement-modal.component.html',
    styleUrls: ['./attach-implement-modal.component.scss'],
    providers: [
        {
            provide: DateAdapter, useClass: OrdinalDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
        }
    ]
})

export class AttachImplementModalComponent {
    equipment: EquipmentList[];
    smu: number;
    cost: number;
    eventDate: Date;
    comment: string;
    jobsiteName: string;
    equipmentName:string;
    ord: OrdinalDateParse = new OrdinalDateParse();

    minDate: Date = new Date();
    maxDate: Date = new Date();

    attachImplementData: AttachImplementModalData;
    savingChanges: boolean = false;

    // Tooltips
    ttDate: string = "Click here to select a date.";
    ttComment: string = "You may enter a maximum of 256 characters.";

    implementId: number;
    implementList: ImplementMakeModelVM[] = [];
    hide:boolean=false;
    hasImplement:boolean=false;
    impName:string;

    jobsiteList: GenericIdName[] = [];
    equipmentList: EquipmentSelectItem[] = [];
    constructor(private _appService: AppService, public dialogRef: MatDialogRef<AttachImplementModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, private _moduleService: AttachImplementModalService,
        public toastr: NotificationsService, vcr: ViewContainerRef, public _implementService: SetupImplementService,
        public _inventoryService: GETInventoryService,private _equipmentService: GETSetupEquipmentService,
        private _favouriteDialogService:FavouriteDialogService) {
        
    }
    ngOnInit() {
        this.attachImplementData = new AttachImplementModalData();
        this.loadCustomers();
        this.eventDate = new Date();
        this.attachImplementData.date = this.eventDate;
        if (this.data.implementId == null) {
            this.data.implementId = this.implementId;
        }
        console.log("DATA",this.data)

        if (this.data != null) {
           
            if (this.data.equipmentId != null) {


                this.hide = true;
                this.attachImplementData.equipmentId = this.data.equipmentId;
                this.equipmentName =this.data.equipmentName;
                this._implementService.GetImplementsInInventoryForModel(this.data.jobsiteId, this.data.modelName, this.data.equipmentId).subscribe(r => {
                    this.implementList = r;
                })
                this.smu= this.data.smu;
                this.attachImplementData.smu=this.smu
            }
            if (this.data.implementId != null) {
               
                this.hasImplement=true;
                this.attachImplementData.implementId = this.data.implementId;
                this.impName = this.data.implementName;
                this._inventoryService.returnMinDateForImplementEvent(this.data.implementId)
                    .subscribe(response => {
                        if (response != "") {
                            try {
                                this.minDate = new Date(response);
                            }
                            catch (ex) {
                                this.minDate = new Date();
                            }
                        }
                    });
            }
            if (this.data.jobsiteId != null) {
                this.attachImplementData.jobsiteId = this.data.jobsiteId;

               
            }
            if (this.data.jobsiteName != null) {
                this.jobsiteName = this.data.jobsiteName;
            }
        }

    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
    saveChanges(): void {
        if (this.savingChanges) {
            return;
        }
        if(this.attachImplementData.cost == null){
            this.attachImplementData.cost = 0;
        }
        if(this.attachImplementData.comment == null){
            this.attachImplementData.comment = "";
        }
        let validation = this.validateData();
        this.savingChanges = true;

        if (validation == ErrorCode.VALIDATION_PASSED) {
            this._moduleService.saveAttachImplement(this.attachImplementData).subscribe(response => {
                if (response == "false") {
                    this.toastr.error(ErrorMessages.ERROR_SAVING);
                    this.savingChanges = false;
                }
                else {
                    this.dialogRef.close(true);
                }
            }, error => { console.log(error); });
        }
        else if (validation == ErrorCode.ERROR_NEGATIVE_COST) {
            this.toastr.error(ErrorMessages.ERROR_NEGATIVE_COST);
            this.savingChanges = false;
        }
        else if (validation == ErrorCode.ERROR_NEGATIVE_SMU) {
            this.toastr.error(ErrorMessages.ERROR_NEGATIVE_SMU);
            this.savingChanges = false;
        }
        else {
            this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
            this.savingChanges = false;
        }
    }
    validateData(): number {
        var returnCode = ErrorCode.VALIDATION_PASSED;


        if (this.attachImplementData.equipmentId
            && this.attachImplementData.smu
            && this.attachImplementData.cost
            && this.attachImplementData.date
            && this.attachImplementData.comment) {
            if (this.attachImplementData.cost < 0) {
                returnCode = ErrorCode.ERROR_NEGATIVE_COST;
            }
            else if (this.attachImplementData.smu < 0) {
                returnCode = ErrorCode.ERROR_NEGATIVE_SMU;
            }
            else {
                returnCode = ErrorCode.VALIDATION_PASSED;
            }
        }

        return returnCode;
    }

    // Equipment
    equipmentSelected(equipmentId): void {
        this.attachImplementData.equipmentId = equipmentId;

        for (var i = 0; i < this.equipment.length; i++) {
            if (this.equipment[i].equipmentId == equipmentId) {
                this.smu = this.equipment[i].equipmentSMU;
                this.attachImplementData.smu = this.smu;
                break;
            }
        }
    }

    implementSelected(v) {
        this.attachImplementData.implementId = v;
    
        this._inventoryService.returnMinDateForImplementEvent(v)
          .subscribe(response => {
            if (response != "") {
              try {
                this.minDate = new Date(response);
              }
              catch (ex) {
                this.minDate = new Date();
              }
            }
          });

         

      }

    // SMU
    smuChanged(): void {
        this.attachImplementData.smu = this.smu;
    }
    // Cost
    costChanged(): void {
        this.attachImplementData.cost = this.cost;
    }

    // Date
    dateChanged(): void {
        this.attachImplementData.date = this.eventDate;
        this.ord.formatDateOrdinal((this.eventDate.toString())
            .split(' ')
            .slice(1)
            .join(' '), false);
    }

    // Comment
    commentChanged(): void {
        this.attachImplementData.comment = this.comment;
    }


    customerList: CustomerSelectItem[] = [];
    selectedCustomer:number[]
    //load cutomers
    loadCustomers() {
        this._equipmentService.getCustomerList().subscribe(r => {
            this.customerList = r;
        });
    }

    //loadjobsite for customer
    customerSelected(x) {
        if (x == null)
            return;
        this.jobsiteList = null;
        var params: JobsiteSelectionFilter = {
            Customers: x,
          }
        this._equipmentService.getJobsiteList(x).subscribe(r => {
            if (r) {
                this.jobsiteList = r;
                console.log(this.jobsiteList)
            }
          });
    }
    jobsiteSelected(v){
        this.attachImplementData.jobsiteId = v;

        this._equipmentService.getEquipmentList(v).subscribe(r => {
            if (r) {
                this.equipmentList = r;
                console.log(this.equipmentList)
            }
          });


          this._moduleService.getCompatibleEquipmentForImplementByJobsite(this.attachImplementData.jobsiteId, this.attachImplementData.implementId).subscribe(response => {
            this.equipment = response;
            console.log(this.equipment)
        }, error => { console.log(error); });
         
    }

    
    
}
